import { Observable, Observer } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { ComplianceFeatureFlagService } from '@services/feature-flags/compliance';
import { LogDetails } from '@app/dashboard/logs/details/log-details.service';

import { getUrlWithoutParams } from '@app/admin/fleet-card/shared/utils';

@Injectable()
export class LogEditGuard implements CanActivate {
  constructor(
    private router: Router,
    private complianceFeatureFlagService: ComplianceFeatureFlagService,
    private service: LogDetails,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    if (this.complianceFeatureFlagService.isComplianceAllowEditBeforeDriverCertifiesLogEnabled()) return true;
    else {
      return new Observable<boolean>((observer: Observer<boolean>) => {
        const params = { ...route.params };
        const id = params.id;
        delete params.id;

        this.service.getOnce(id, params).subscribe(data => {
          const log = data.log.viewModel;
          if (!log.driverSignature.url) {
            observer.next(false);
            observer.complete();

            const urlWithoutParams: string = getUrlWithoutParams(state.url.replace('/edit', ''), this.router);
            this.router.navigate([urlWithoutParams, params]);
          } else {
            observer.next(true);
            observer.complete();
          }
        });
      });
    }
  }
}
